import { constants } from 'quasar-pilot-core/src/lib/constants';

constants.DEFAULT_LOCATION = 1;
constants.DEFAULT_DELIVERY_METHOD = 1;
constants.DEFAULT_PAYMENT_METHOD = 1;
constants.CATEGORY_OFFER = 'category-offer';
constants.CATEGORY_FRONTPAGE = 'category-frontpage';

constants.SESSION_COOKIE_USER_ID = 'galleryUserUid';
constants.SESSION_COOKIE_LOCATION_ID = 'galleryLocationUid';

constants.LOCATIONS = [
  {
    name: 'Hella',
    address: 'Landvegamót',
    address2: '851 Hella',
    phoneNumber: '487 8440',
    image: '/images/loc1.jpeg',
    openingHours1: '11:30 - 21:00',
    orderUrl: '',
  },
  {
    name: 'Hvolsvöllur',
    address: 'Hvolsvegur 29',
    address2: '860 Hvolsvöllur',
    phoneNumber: '487 8440',
    image: '/images/loc2.jpeg',
    openingHours1: '11:30 - 21:00',
    orderUrl: '',
  },
];

export default constants;
